import { styled } from '@mui/material/styles';
import { TextField, RadioGroup, Radio } from '@mui/material';

const ProvisioningStyles = {
    stack: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    configure: {
        stack: { alignItems: 'center', justifyContent: 'space-between' },
        boxWrapper: { width: '60%', bgcolor: (theme) => theme.palette.white },
        btnWrapper: { width: '60%', ml: (theme) => theme.spacing(0.25) },
        badgeWidth: { width: '100%' },
        configureBtn: {
            // paddingTop: (theme) => theme.spacing(1),
            // paddingBottom: (theme) => theme.spacing(1),
            // height: (theme) => theme.spacing(4.641),
            // fontSize: { md: (theme) => theme.spacing(1.25), lg: (theme) => theme.spacing(1.5) },
            // textWrap: 'no-wrap',

            font: (theme) => `${theme.typography.fontSize.$font_xsmall_caps}!important`,
            // color: (theme) => theme.palette.interAction.$color_interaction_active,
            textTransform: 'none',
            borderRadius: (theme) => theme.palette.border.$border_radius,
            padding: '3px 15px',
            height: '24px',
            backgroundColor: (theme) => theme.palette.background.$color_background_button_primary,
            border: (theme) => `1px solid ${theme.palette.border.$color_border_secondary_button}`,
            width: '130px',
            '&:hover': {
                background: (theme) => theme.palette.button.$color_button_primary_hover,
            },
            '&:active': {
                background: (theme) => theme.palette.button.$color_button_primary_active,
            },
        },
        editCatlogueBtn: {
            font: (theme) => `${theme.typography.fontSize.$font_xsmall_caps}!important`,
            borderRadius: (theme) => theme.palette.border.$border_radius,
            color: (theme) => theme.palette.interAction.$color_interaction_active,
            padding: '3px 15px',
            width: '130px',
            // fontWeight: '700',
            // fontSize: '14px !important',
            backgroundColor: 'transparent',
            height: '24px',
            border: (theme) => `1px solid ${theme.palette.border.$color_border_secondary_button}`,
            '&:hover': {
                color: (theme) => theme.palette.border.$color_border_secondary_button_hover,
                border: (theme) => `1px solid ${theme.palette.border.$color_border_secondary_button_hover}`,
                backgroundColor: 'transparent',
            },
            '&:active': {
                color: (theme) => theme.palette.button.$color_button_primary_active,
                border: (theme) => `1px solid ${theme.palette.button.$color_button_primary_active} !important`,
            },
        },
    },
    costCenter: { width: '100%' },
    helpMessage: { color: '#d40020' },
    disposal: {
        infoIcon: { color: (theme) => theme.palette.gray.main },
        helpText: { color: '#d40020' },
    },
    card: {
        paper: {
            padding: (theme) => theme.spacing(2),
            background: (theme) => theme.palette.gray.lighter,
            height: (theme) => theme.spacing('100%'),
        },
        form: {
            '& > *': {
                marginBottom: (theme) => theme.spacing(2.5),
            },
        },

        box: { mb: (theme) => theme.spacing(0.375) },
        typography: { marginBottom: (theme) => theme.spacing(0.25) },
    },
    modalBox: {
        wrapper: {
            minWidth: (theme) => theme.spacing(65),
            width: (theme) => theme.spacing(75),
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            overflow: 'hidden',
        },
        contentWrapper: { overflow: 'auto', flexGrow: 1, px: (theme) => theme.spacing(2) },
        actionWrapper: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end', p: (theme) => theme.spacing(2) },
        cancelBtn: {
            marginLeft: (theme) => theme.spacing(1.25),
            color: '#6E6F6F',
            textTransform: 'none',
            border: '2px solid #707070',
            '&:hover': {
                color: '#6E6F6F',
                border: '2px solid #707070',
                background: 'transparent',
            },
        },
        warningTypography: { color: (theme) => theme.palette.red.light },
    },
    envContainer: {
        badge: { marginRight: (theme) => theme.spacing(2) },
        samBtn: {
            marginRight: (theme) => theme.spacing(2),
            color: (theme) => theme.palette.blue.main,
            borderWidth: (theme) => theme.spacing(0.25),
            borderStyle: 'solid',
            textTransform: 'none',
            borderColor: (theme) => theme.palette.blue.main,
            '&:hover': {
                color: (theme) => theme.palette.cyan.main,
                borderWidth: (theme) => theme.spacing(0.25),
                borderStyle: 'solid',
                borderColor: (theme) => theme.palette.cyan.main,
                background: 'transparent',
            },
        },
        applicationBtn: {
            borderWidth: (theme) => theme.spacing(0.125),
            borderStyle: 'solid',
            textTransform: 'none',
            borderColor: (theme) => theme.palette.cyan.main,
            color: (theme) => theme.palette.cyan[70],
        },
        outlinedBtn: {
            color: (theme) => theme.palette.blue.main,
            textTransform: 'none',
            borderWidth: (theme) => theme.spacing(0.25),
            borderStyle: 'solid',
            borderColor: (theme) => theme.palette.blue.main,
            '&:hover': {
                color: (theme) => theme.palette.cyan.main,
                borderWidth: (theme) => theme.spacing(0.25),
                borderStyle: 'solid',
                borderColor: (theme) => theme.palette.cyan.main,
                background: 'transparent',
            },
        },
        tagBtn: { textTransform: 'none' },
    },
    fqdnModal: {
        delete: {
            // fontSize: (theme) => theme.spacing(2.25),
            // fill: '#FFFFFF',
            // color: (theme) => theme.palette.white,
            cursor: 'pointer',
            width: '16px',
            height: '16px',
        },
        deleteWrapper: {
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: (theme) => theme.spacing(3),
            height: (theme) => theme.spacing(3),
            // background: '#F4273B',
            mb: '5px !important',
        },
    },
    cartBtn: {
        width: (theme) => theme.spacing(18.75),
        height: (theme) => theme.spacing(4.375),
        textTransform: 'none',
    },
    provisonBtn: {
        width: (theme) => theme.spacing(23.75),
        height: (theme) => theme.spacing(4.375),
        textTransform: 'none',
    },
    Dialog: {
        title: { fontSize: '24px', fontWeight: 'bold', color: '#000000', paddingTop: '15px', paddingBottom: '10px' },
        msgDiv: { fontSize: '12px', fontWeight: 'normal', padding: '5px 11px' },
        wrapper: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            width: '428px',
            height: '225px',
            paddingTop: '20px',
            paddingBottom: '5px',
        },
        IconColor: '#C02223',
        icon: { fill: '#C02223', fontSize: '60px' },
        AzIcon: '#d02424',
        backBtnBox: { display: 'flex', justifyContent: 'center', mt: (theme) => theme.spacing(2), paddingBottom: '5px' },
        backBtn: { paddingX: '65px', textTransform: 'none' },
        AgreeBtn: {
            marginLeft: (theme) => theme.spacing(1.25),
            paddingX: '65px',
            textTransform: 'none',
            color: '#0047BA',
            border: '2px solid #0047BA',
            '&:hover': {
                color: '#00A0DD',
                border: '2px solid #00A0DD',
                background: 'transparent',
            },
        },
    },
    serverRefresh: {
        textField: {
            input: {
                '&::placeholder': {
                    textAlign: { md: 'left', lg: 'left' },
                    fontSize: { md: (theme) => theme.spacing(1.625), lg: (theme) => theme.spacing(1.75) },
                    color: '#707070',
                    opacity: (theme) => theme.spacing(1),
                },
            },
            '& .MuiOutlinedInput-root': {
                display: { md: 'flex' },
                flexDirection: { md: 'row', lg: 'row' },
            },
        },
        radioGroup: {
            display: 'flex',
            justifyContent: 'right',
            width: 'inherit',
            fontSize: { md: (theme) => theme.spacing(1.25) },
            mr: { md: (theme) => theme.spacing(-2.25) },
            '& .MuiSvgIcon-root': {
                fontSize: { md: (theme) => theme.spacing(1.875), lg: (theme) => theme.spacing(2.25) },
            },
        },
        radioBtnNo: {
            '& .MuiSvgIcon-root': {
                fontSize: { md: (theme) => theme.spacing(1.875), lg: (theme) => theme.spacing(2.25) },
            },
        },
        radioBtnNoForm: {
            '& .css-j204z7-MuiFormControlLabel-root label': {
                marginRight: (theme) => theme.spacing(1.25),
            },
        },
    },
    submitOrder: {
        wrapper: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' },
        orderIdTypo: { color: (theme) => theme.palette.blue.main, textDecoration: 'underline', cursor: 'pointer', mx: (theme) => theme.spacing(1) },
        actionWrapper: { textAlign: 'center', my: (theme) => theme.spacing(0.25), py: (theme) => theme.spacing(2) },
        newOrder: { marginRight: (theme) => theme.spacing(2) },
        message: { fontSize: '30px', fontWeight: 500, color: (theme) => theme.palette.black.dark },
        description: { width: '500px', fontSize: '16px', fontWeight: 400, color: (theme) => theme.palette.black.dark },
        checkOutBtn: {
            width: '180px',
            textTransform: 'none',
            color: '#0047BA',
            border: '2px solid #0047BA',
            '&:hover': {
                color: '#00A0DD',
                borderWidth: '2px',
                border: '2px solid #00A0DD',
                backgroundColor: 'white',
            },
        },
    },

    ProvisioningHeader: {
        pageTitle: {
            color: (theme) => theme.palette.white,
            textTransform: 'uppercase',
            fontSize: (theme) => theme.spacing(2),
            mx: (theme) => theme.spacing(0.5),
        },
        header: {
            mx: (theme) => theme.spacing(6.625),
            mt: (theme) => theme.spacing(3.125),
        },
        gridContainer: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
        gridItem: { display: 'flex' },
        ImgSpan: { marginRight: '4px' },
        img: { width: 26 },
        catalogsApiLoadingSpan: {
            background: '#E0E0E0',
            width: 33,
            height: 33,
            marginRight: '4px',
            borderRadius: '50%',
        },
        infoIcon: { fill: '#0047BA', color: '#ffffff', fontSize: '24px', marginRight: '10px !important', marginLeft: '5px' },
        warningIcon: { fill: '#D78B95', height: (theme) => theme.spacing(3), width: (theme) => theme.spacing(3), mt: (theme) => theme.spacing('-3px') },
        errorAlert: {
            backgroundColor: '#AE172B',
            color: '#FFFFFF',
            display: 'flex ',
            alignItems: 'center ',
            justifyContent: 'center ',
            fontSize: 14,
            '& .MuiAlert-action': {
                display: 'none',
            },
        },
    },
    provisioning_wrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: (theme) => theme.spacing('100%'),
        height: 'calc(100vh - 100px)',
    },
    sspform_wrapper: { flexGrow: 1 },
    provisioningBox: {
        display: 'flex',
        flexDirection: 'column',
        // overflowY: 'scroll',
        width: (theme) => theme.spacing('100%'),
        height: (theme) => theme.spacing('100%'),
    },
    circularProgressColor: { color: (theme) => theme.palette.black.dark },
    tags: {
        wrapper: { minWidth: (theme) => theme.spacing(75), width: (theme) => theme.spacing(100), display: 'flex', flexDirection: 'column', height: '100%' },
        contentWrapper: { flexGrow: 1, px: (theme) => theme.spacing(2) },
        box: { display: 'flex', flexDirection: 'column' },
        titlebox: { fontSize: (theme) => theme.spacing(1.875), display: 'flex', mb: (theme) => theme.spacing(2) },
        name: { fontWeight: 'bold', width: '31%' },
        colon: { width: (theme) => theme.spacing(0.25), mx: 1.5 },
        val: { width: (theme) => theme.spacing(50), fontWeight: 'bold', flexGrow: 1 },
        dataWrapper: { fontSize: (theme) => theme.spacing(1.875), display: 'flex', mb: (theme) => theme.spacing(1) },
        dataNameWrapper: {
            display: 'flex',
            alignItems: 'center',
            width: '30%',
            borderWidth: (theme) => theme.spacing(0.125),
            borderStyle: 'solid',

            borderRadius: (theme) => theme.spacing(0.25),
            borderColor: 'gray.lowMedium',
            py: (theme) => theme.spacing(0.5),
            px: (theme) => theme.spacing(1.5),
        },
        dataColan: { width: (theme) => theme.spacing(0.75), mx: (theme) => theme.spacing(1) },
        dataValueBoxWrapper: { flexGrow: 1 },
        actionWrapper: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end', p: (theme) => theme.spacing(0.25) },
        resetBtn: {
            marginLeft: (theme) => theme.spacing(1.25),
            color: '#6E6F6F',
            textTransform: 'none',
            border: '2px solid #707070',
            '&:hover': {
                color: '#6E6F6F',
                border: '2px solid #707070',
                background: 'transparent',
            },
        },
        activeSelectField: {
            background: 'transparent',
            '& label.MuiFormLabel-filled,label.MuiInputLabel-shrink': {
                color: '#0047BA',
                padding: '0 2px',
            },
            '& label.Mui-disabled+div fieldset': {
                border: ' 1px solid #E9E9E9',
            },
            '& label.MuiFormLabel-filled+div fieldset': {
                border: ' 1px solid #0047BA',
            },
            '& label.Mui-focused+div fieldset': {
                border: ' 2px solid #0047BA !important',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#0047BA',
            },
        },
    },

    orderSuccesss: {
        wrapper: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' },
        orderIdTypography: { color: (theme) => theme.palette.blue.main, textDecoration: 'underline', cursor: 'pointer', mx: (theme) => theme.spacing(1) },
        nsgOrderIdTypography: { color: (theme) => theme.palette.blue.main, textDecoration: 'none', mr: (theme) => theme.spacing(0.5) },
        newOrderBox: { textAlign: 'center', my: (theme) => theme.spacing(1) },
        newOrderBtn: { marginRight: (theme) => theme.spacing(2), textTransform: 'none' },
        thankyouTypography: { textAlign: 'center' },
        backHome: {
            textTransform: 'none',
            color: '#0047BA',
            border: '2px solid #0047BA',
            '&:hover': {
                color: '#00A0DD',
                borderWidth: '2px',
                border: '2px solid #00A0DD',
                backgroundColor: 'white',
            },
        },
    },

    securityScan: {
        wrapper: { display: 'flex', alignItems: 'center', flexDirection: 'row' },
        formControl: { height: '127.13px', justifyContent: 'center', marginLeft: 1 },
        formControlHeader: { color: '#616161', fontSize: '14px', fontWeight: 'normal' },
        stack: { paddingLeft: '10px', paddingTop: '8px' },
        typography: { color: '#616161', fontSize: '14px', fontWeight: 'normal' },
    },
    isaValidation: {
        wrapper: { display: 'flex', alignItems: 'center', flexDirection: 'column' },
        formControl: { height: '67.13px', justifyContent: 'Left', marginLeft: 0, flexDirection: 'row', alignItems: 'center' },
        formControlHeader: { color: '#616161', fontSize: '14px', fontWeight: 'normal', textAlign: 'left' },
        stack: { paddingLeft: '10px', paddingTop: '8px' },
        typography: { color: '#616161', fontSize: '14px', fontWeight: 'normal' },
    },
    uploadImageWrapper: {
        color: (theme) => theme.palette.cmpPrimary.main,
        fontSize: '12px',
        fontFamily: (theme) => theme.typography.fontFamily,
        fontWeight: 'normal',
        pb: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '10px',
    },
};

export const ServerTextField = styled(TextField)(({ theme }) => ({
    '& label.Mui-focused': {
        color: theme?.palette?.blue?.main,
    },
    '& label.MuiFormLabel-filled': {
        color: theme?.palette?.blue?.main,
        padding: theme?.spacing(0.2),
    },
    '& .MuiInputBase-input': {
        color: theme?.palette?.blue?.dark,
        background: theme?.palette?.white,
        '&.Mui-disabled': {
            background: 'transparent',
        },
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: theme?.palette?.gray?.light,
            color: '#AFB8CC',
        },
        '&:hover fieldset': {
            borderColor: theme?.palette?.gray?.light,
        },
        '&.Mui-focused fieldset': {
            borderColor: theme?.palette?.gray?.light,
        },
    },
    input: {
        '&::placeholder': {
            [theme.breakpoints.only('md')]: {
                fontSize: theme.spacing(1.625),
                textAlign: 'left',
            },
            [theme.breakpoints.only('lg')]: {
                fontSize: theme.spacing(1.75),
                textAlign: 'left',
            },
            color: '#707070',
            opacity: 1,
        },
    },
}));
export const CustomRadioGroup = styled(RadioGroup)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'left',
    width: 'inherit',
    [theme.breakpoints.only('md')]: {
        fontSize: theme.spacing(1.25),
        marginRight: theme.spacing(-2.15),
    },
    '& .MuiSvgIcon-root': {
        [theme.breakpoints.only('md')]: {
            fontSize: theme.spacing(1.875),
        },
        [theme.breakpoints.only('lg')]: {
            fontSize: theme.spacing(2.25),
        },
    },
}));

export const CustomRadio = styled(Radio)(({ theme }) => ({
    [theme.breakpoints.only('md')]: {
        fontSize: theme.spacing(1.875),
    },
    [theme.breakpoints.only('lg')]: {
        fontSize: theme.spacing(2.25),
    },
}));
export default ProvisioningStyles;
